import Vue from 'vue';
import App from './App.vue';
import router from './router';
import LoginPlugin from './loginPlugin';
import ElementUI from 'element-ui';
import request from './request' // 引入请求拦截器
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(LoginPlugin);

Vue.prototype.$http = request
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');